import { safeLocalStorage } from '../utils/storage';

const NEWSLETTER_SIGNUP_KEY = 'newsletter_signed_up';
const NEWSLETTER_LAST_SHOWN_KEY = 'newsletter_last_shown';
const THREE_WEEKS_MS = 21 * 24 * 60 * 60 * 1000; // 3 weeks in milliseconds

interface NewsletterModalState {
  shouldShowModal: () => boolean;
  markAsShown: () => void;
  markAsSignedUp: () => void;
}

export const useNewsletterModalState = (): NewsletterModalState => {
  const shouldShowModal = (): boolean => {
    // Check if user has already signed up
    const hasSignedUp = safeLocalStorage.getItem(NEWSLETTER_SIGNUP_KEY) === 'true';
    if (hasSignedUp) {
      return false;
    }

    // Check if modal was shown in the last 3 weeks
    const lastShown = safeLocalStorage.getItem(NEWSLETTER_LAST_SHOWN_KEY);
    if (lastShown) {
      const lastShownTime = parseInt(lastShown, 10);
      const now = Date.now();
      const timeSinceLastShown = now - lastShownTime;

      if (timeSinceLastShown < THREE_WEEKS_MS) {
        return false;
      }
    }

    return true;
  };

  const markAsShown = () => {
    safeLocalStorage.setItem(NEWSLETTER_LAST_SHOWN_KEY, Date.now().toString());
  };

  const markAsSignedUp = () => {
    safeLocalStorage.setItem(NEWSLETTER_SIGNUP_KEY, 'true');
  };

  return {
    shouldShowModal,
    markAsShown,
    markAsSignedUp,
  };
};
